import * as d3 from "d3";
  
  /**
   * Update Lines Width
   * @param {*} strokeWidth 
   */
  export function updateLineWidth(strokeWidth) {
    let scope = this;
    if (strokeWidth) {
      if (strokeWidth < 0) strokeWidth = 0;
      this.strokeWidth = strokeWidth;
      if (this.strokeWidth > 0) {
        scope.arrayElements.forEach(groupID => {
          d3.select(scope.canvas).selectAll('#' + groupID).selectAll(scope.types).each(function (d, i) {
            if (this.getAttribute("data-isStroke") == "true") this.style.strokeWidth = strokeWidth;
          })
        });
      }
      else {
        scope.arrayElements.forEach(groupID => {
          d3.select(scope.canvas).selectAll('#' + groupID).selectAll(scope.types).each(function (d, i) {
            if (this.style.strokeWidth) this.style.strokeWidth = null;
          })
        });
      }
    }
    // Ensure hover style is not overridden
    if (scope.hoverWidth !== strokeWidth) {
      scope.updateHoverWidth(scope.hoverWidth);
    }
  }

  /**
   * Updates the hover width of elements in the Viewer.
   * @param {number} hoverWidth - The new hover width to apply.
   */
  export function updateHoverWidth(hoverWidth) {
    let scope = this;
    if (hoverWidth) {
      if (hoverWidth < 0) hoverWidth = NaN;
      scope.hoverWidth = hoverWidth;
      scope.strokeWidth = hoverWidth;

      let content = scope.interaction;
      var elements = content.selectAll(scope.types);

      elements.each(function () {
        var elem = d3.select(this);
        if (elem.attr("data-isStroke") == "true") {
          elem.style("stroke", scope.hoverColor);
          elem.style("stroke-width", `${hoverWidth}px`);
        }
        if (elem.attr("data-isFill") == "true") {
          elem.style("fill", scope.hoverColor);
        }
      });
    }
  }